import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import stripHtml from 'src/utils/stripHtml';

import ContentOverviewHeaderContainer from '../_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import styles from './ContentOverviewWhyReadArticle.module.css';

type ContentOverviewWhyReadArticleProps = ComponentProps & {
	fields: {
		WhyReadArticleTitle: Field<string>;
		Information?: Field<string>;
	};
};

export default function ContentOverviewWhyReadArticle(props: ContentOverviewWhyReadArticleProps): JSX.Element {
	if (!props.fields.Information || !props.fields.Information.value.toLowerCase().includes('why you should read this article')) {
		return <></>;
	}

	const reasonsArray: string[] = [];

	stripHtml(props.fields?.Information?.value)
		.split(/\r?\n|\r|\n/g)
		.map((reason) => {
			const trimReason = reason
				.replace(/&bull;/g, '')
				.replace(/&nbsp;/g, ' ')
				.replace(/&lsquo;/g, `'`)
				.replace(/&rsquo;/g, `'`)
				.replace(/&ldquo;/g, `"`)
				.replace(/&rdquo;/g, `"`)
				.replace(/&ndash;/g, '-')
				.replace(/&sbquo;/g, ',')
				.replace(/&hellip;;/g, '...')
				.trim();
			trimReason != '' && reasonsArray.push(trimReason);
		});

	reasonsArray.shift();

	return (
		<section id="resource-navigation">
			<ContentOverviewHeaderContainer header={props.fields.WhyReadArticleTitle?.value} />
			<div className={styles.container}>
				{reasonsArray.map((reason, index) => (
					<div key={index} className={styles.reasonItem}>
						<p className={styles.reasonText}>{reason}</p>
					</div>
				))}
			</div>
		</section>
	);
}
